export default __webpack_public_path__ + "static/media/people1.4706675f.svg";